import React from 'react'

const MyTimeOff = () => {
    return (
        <div>MyTimeOff</div>
    )
}

export default MyTimeOff